import { render, staticRenderFns } from "./region-navigation-header.vue?vue&type=template&id=fdde44fa&scoped=true&"
import script from "./region-navigation-header.vue?vue&type=script&lang=js&"
export * from "./region-navigation-header.vue?vue&type=script&lang=js&"
import style0 from "./region-navigation-header.vue?vue&type=style&index=0&id=fdde44fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdde44fa",
  null
  
)

export default component.exports